
import { InvoicesProvider } from "@/modules/reporting/domain/InvoicesProvider";

export class DownloadSummaryCommand {
    constructor(
        private readonly invoices_provider : InvoicesProvider,
        private readonly screen_data,
        private date_range,
        private done,
        private get_deleted: boolean=false,
    ) {}

    async run(user_id_num: number) {
        this.screen_data.ui_download_summary_loading = true
        let resOutput
        try {
            if (!this.get_deleted) {
                resOutput = await this.invoices_provider.find_by_date_range_and_done(this.date_range.after, this.date_range.before, this.done)
            }
            else {
                resOutput = await this.invoices_provider.find_by_date_range(this.date_range.after, this.date_range.before, this.get_deleted)
            }
            
        } catch (error) {
            console.error('Error getting file download url', error)
            resOutput = null
        }
        this.screen_data.ui_download_summary_loading = false
        return resOutput
    }
}